var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.25V6.875C14 6.75857 13.9729 6.64373 13.9208 6.53959C13.8687 6.43545 13.7931 6.34486 13.7 6.275L8.45 2.3375C8.32018 2.24013 8.16228 2.1875 8 2.1875C7.83772 2.1875 7.67982 2.24013 7.55 2.3375L2.3 6.275C2.20685 6.34486 2.13125 6.43545 2.07918 6.53959C2.02711 6.64373 2 6.75857 2 6.875V13.25C2 13.4489 2.07902 13.6397 2.21967 13.7803C2.36032 13.921 2.55109 14 2.75 14H5.75C5.94891 14 6.13968 13.921 6.28033 13.7803C6.42098 13.6397 6.5 13.4489 6.5 13.25V11C6.5 10.8011 6.57902 10.6103 6.71967 10.4697C6.86032 10.329 7.05109 10.25 7.25 10.25H8.75C8.94891 10.25 9.13968 10.329 9.28033 10.4697C9.42098 10.6103 9.5 10.8011 9.5 11V13.25C9.5 13.4489 9.57902 13.6397 9.71967 13.7803C9.86032 13.921 10.0511 14 10.25 14H13.25C13.4489 14 13.6397 13.921 13.7803 13.7803C13.921 13.6397 14 13.4489 14 13.25Z",
    stroke: "#05B97D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1b4740dafaeabda09df6768f6e02e71b.svg";
export { ForwardRef as ReactComponent };